import React, { useEffect } from 'react';
import AvailabilityCalendar from './AvailabilityCalendar';
import '../CSS/style/Availability.css';

/** 메인 배너의 '실시간 예약현황' 버튼으로 여는 달력 팝업 */
const AvailabilityModal = ({ onClose }) => {

    useEffect(() => {
        // ESC 로 닫기 + 팝업이 떠 있는 동안 뒤 배경 스크롤 잠금
        const onKeyDown = (e) => { if (e.key === 'Escape') onClose(); };
        const prevOverflow = document.body.style.overflow;

        document.addEventListener('keydown', onKeyDown);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = prevOverflow;
        };
    }, [onClose]);

    return (
        <div className="avail-modal-backdrop" onClick={onClose}>
            <div
                className="avail-modal"
                role="dialog"
                aria-modal="true"
                aria-label="실시간 예약현황"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="avail-modal-head">
                    <div>
                        <span className="avail-modal-label">AVAILABILITY</span>
                        <h2 className="avail-modal-title">실시간 예약현황</h2>
                    </div>
                    <button type="button" className="avail-modal-close" onClick={onClose} aria-label="닫기">✕</button>
                </div>

                <div className="avail-modal-body">
                    <AvailabilityCalendar variant="modal" />
                </div>
            </div>
        </div>
    );
};

export default AvailabilityModal;